import React, {useState, useEffect} from 'react'
import { Dialog } from '@alifd/next';
import Xman from '@alife/alpha-xman/xpopup';
import safeLog from '@alife/bc-safe-log';
import {createI18N} from '@alife/bc-i18n'
import SkuLayout from './sku-layout'
import SkuPayment from './sku-payment'
import getValue from './getValue'
import ContextManager from './context-manager'

import './index.scss'

const I18n = createI18N({
    namespace: 'undue_tpl_helpers'
});

const xman = new Xman({
    members: 'both',
    locale: 'en_US',
    align: {
      selfXY: ['50%', -30],
      baseXY: ['50%', 0],
    },
  });

export default function Index({text}) {
    const [visible, setVisible] = useState(false)
    const [data, setData] = useState([])
    const [skuIds, setSkuIds] = useState(null)
    // 产品ID
    const [productId, setProductId] = useState(null)
    // 是否显示提示
    const [tipShow, setTipShow] = useState(false)
    const [postData, setPostData] = useState({
        skuInfo: [],
        // 选择skuID数据
        selected: {},
        // 所有SKU组合
        skus: {},
    })
    
    const onClose = () => {
        setTipShow(false)
        setVisible(false)
    }
    useEffect(() => {
        I18n.parsePage();
        if (visible) {
            const productSampleSku =getValue('productSampleSku');
            const productSkuInfo = getValue("productSkuInfo")
            const productId = getValue('detailId')
            // 更新sku组合
            const skus = {};
            productSampleSku.map(sku => {
                const ids = sku.values.map(item => item.id).join('-')
                skus[ids] = {
                    price: sku.price,
                    number: 0,
                    skuId: sku.id
                }
            })
            
            setData(productSampleSku)
            setProductId(productId)
            setPostData({
                ...postData,
                skuInfo: productSkuInfo,
                skus,
            })
        }
    }, [visible])

    const handleLogin = cb => {
        xman.show();
        xman.on(
          'LOGIN_SUCCESS',
          cb ||
            function() {
              location.reload();
            },
        );
    };

    const handleSelect = (type, id, data) => {
        const temp = Object.assign({}, postData)
        const {selected, skus} = temp
        // 更新选中
        if (type === 'price') {
            safeLog(
                '/sc.details.getSample',
                'CLK',
                `from=opensku&type=select&pid=${productId}`,
                'GET',
            );

            selected[id] = data
        }

        // 更新选择sku id 
        const ids = Object.values(selected).map(i => i.id)
        setSkuIds(ids.join('-'))
        
        // 更新数字
        if (type === 'number') {
            safeLog(
                '/sc.details.getSample',
                'CLK',
                `from=opensku&type=number&pid=${productId}`,
                'GET',
            );
            ids.push(id)
            const skuData = skus[ids.join('-')]
            skuData.number = data
            skuData.total = parseFloat(skuData.price) * skuData.number
        }
        setPostData(temp)
    }

    const checkSKU = (e) => {
        e.preventDefault();
        const productSampleSku =getValue('productSampleSku');
        const productId = getValue('detailId')
        if (productSampleSku.length > 1) {
            e.nativeEvent.stopImmediatePropagation();
            if (!xman.isLoggedIn()) {
                safeLog(
                    '/sc.details.getSample',
                    'CLK',
                    `from=opensku&type=dialog&needlogin&pid=${productId}`,
                    'GET',
                );
                handleLogin();
                return;
            }
            safeLog(
                '/sc.details.getSample',
                'CLK',
                `from=opensku&type=dialog&alreadylogin&pid=${productId}`,
                'GET',
            );
            setVisible(true)
        }else{
            const inventoryData = getValue('inventoryData') || {};

            let data
            if (productSampleSku.length === 0) {
                data = [{
                    productId,
                    "dispatchLocation":inventoryData.defaultDispatchId || 'CN',
                }]
            }else{
                data = productSampleSku.map(item => ({
                    productId,
                    "dispatchLocation":inventoryData.defaultDispatchId || 'CN',
                    "skuId":item.id,
                    "quantity": 1
                }))
            }
            safeLog(
                '/sc.details.getSample',
                'CLK',
                `from=opensku&result=success&type=simple&pid=${productId}`,
                'GET',
            );
            window.location = `//biz.alibaba.com/contract/SampleOrder.htm?data=${encodeURIComponent(JSON.stringify(data))}&tracelog=from_detail_get_sample`
        }
    }

    return (
        [<a href="#" onClick={checkSKU}>
            <i className="item-icons ui2-icon ui2-icon-box"></i>
            {text}
        </a>,
        <Dialog
            title={I18n.get('sample')}
            visible={visible}
            footer={false}
            shouldUpdatePosition
            style={{
                width: "840px"
            }}
            onClose={onClose}>
                <ContextManager.Provider value={{
                    // SKU数据
                    postData,
                    // 选择SKU属性类目ID
                    I18n,
                    skuIds,
                    productId,
                    tipShow,
                    setTipShow,
                    handleSelect
                }}>
                    <div className="sku-dialog">
                        <SkuLayout productSampleSku={data} I18n={I18n}/>
                        <SkuPayment/>
                    </div>
                </ContextManager.Provider>
        </Dialog>]
    )
}
